// extracted by mini-css-extract-plugin
module.exports = {"Container":"Box_Container__R5HLi"};